import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

const initialState = {
  prospectLeadTable: {
    loading: false,
    data: [],
    meta: {},
  },

  loading: false,
  success: false,

  leadStatuses: [],
  AssignedUser: [],
  lsqTable: {
    loading: false,
    data: [],
    meta: {},
  },
};

//===================prospected leads table =============================
// get
export const getProspectLeadsTable = createAsyncThunk('global/getProspectLeadsTable', async (params, action) => {
  const { page = 1, limit = 50, type = 'all', search = '', status, project } = params;

  const searchParams = new URLSearchParams({
    page: page,
    limit: limit,
    type: type,
    search: search,
    status:status,
    project: project,
    // ...(status ? { status } : {}),
    // status: status === undefined ? 'null' : status,
    // project: project === undefined ? 'null' : project,
  })

  const res = await apiRequest({
    method: 'get',
    url: `prospect-leads?${searchParams}`,
  });
  if (params.limit == 'no') {
    return action.rejectWithValue(res);
  }
  return res;
});

//--------------------------add prospect lead

export const addProspectLead = createAsyncThunk('global/addProspectLead', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `prospect-leads/add`,
    data: Array.isArray(data) ? data : [data],
  });
  return res;
});

//--------------------update prospect lead

export const updateProspectLead = createAsyncThunk('global/updateProspectLead', async ({ id, data }) => {
  const res = await apiRequest({
    method: 'patch',
    url: `prospect-leads/${id}`,
    data: data,
  });

  return res;
});
//--------------------------get prospect lead status

export const getProspectLeadStatuses = createAsyncThunk('global/getProspectLeadStatuses', async () => {
  const res = await apiRequest({
    method: 'get',
    url: 'prospect-leads/statuses',
  });
  return res;
});

//--------------------------update prospect lead status

export const updateProspectLeadStatuses = createAsyncThunk('global/updateProspectLeadStatuses', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: 'prospect-leads/status-update',
    data: data,
  });
  return res;
});

//----------------------update prospect lead transfer

export const transferProspectLeadDepartment = createAsyncThunk(
  'global/transferProspectLeadDepartment',
  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: 'prospect-leads/dept-transfer-or-assign-employee',
      data: data,
    });
    return res;
  },
);

export const getAssignableUsers = createAsyncThunk('global/getAssignableUsers', async () => {
  const res = await apiRequest({
    method: 'get',
    url: 'prospect-leads/get-direct-reportees',
  });
  return res;
});

export const addAssignProspectLead = createAsyncThunk(
  'global/addAssignProspectLead',

  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: 'prospect-leads/dept-transfer-or-assign-employee',
      data: data,
    });
    return res;
  },
);

export const getLsqProspects = createAsyncThunk('global/getLsqProspects', async (params) => {
  const { page = 1, limit = 50, search = '' } = params;

  const searchParams = new URLSearchParams({
    page: page,
    limit: limit,
    search: search,
  }).toString();

  const res = await apiRequest({
    method: 'get',
    url: `prospect-leads/lsq-leads?${searchParams}`,
  });
  return res;
});

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    clearstate: (state, action) => {
      return {
        ...state,
        state: [],
      };
    },
    clearDistrict: (state, action) => {
      return {
        ...state,
        district: [],
      };
    },
  },
  extraReducers: (builder) => {
    //-----------------prospect Leads Table
    builder.addCase(getProspectLeadsTable.pending, (state) => {
      state.prospectLeadTable.loading = true;
    });

    builder.addCase(getProspectLeadsTable.fulfilled, (state, action) => {
      state.prospectLeadTable.loading = false;

      state.prospectLeadTable.data = action.payload.data || [];
      state.prospectLeadTable.meta = action.payload?.meta;
    });
    builder.addCase(getProspectLeadsTable.rejected, (state) => {
      state.prospectLeadTable.loading = false;
    });
    //----------------ADD LEAD
    builder.addCase(addProspectLead.pending, (state) => {
      state.loading = true;
      state.success = false;
    });

    builder.addCase(addProspectLead.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    });

    builder.addCase(addProspectLead.rejected, (state) => {
      state.loading = false;
      state.success = false;
    });

    // update lead

    builder.addCase(updateProspectLead.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateProspectLead.fulfilled, (state) => {
      state.loading = false;
    });

    builder.addCase(updateProspectLead.rejected, (state) => {
      state.loading = false;
    });

    //--------------------get status
    builder.addCase(getProspectLeadStatuses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProspectLeadStatuses.fulfilled, (state, action) => {
      state.loading = false;
      state.leadStatuses = action.payload.data;
    });
    builder.addCase(getProspectLeadStatuses.rejected, (state) => {
      state.loading = false;
    });

    //-------------------update status
    builder.addCase(updateProspectLeadStatuses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateProspectLeadStatuses.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateProspectLeadStatuses.rejected, (state) => {
      state.loading = false;
    });

    //-------------------transfer department
    builder.addCase(transferProspectLeadDepartment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(transferProspectLeadDepartment.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(transferProspectLeadDepartment.rejected, (state) => {
      state.loading = false;
    });

    //--------------Assign user

    builder.addCase(getAssignableUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAssignableUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.AssignedUser = action.payload.data;
    });
    builder.addCase(getAssignableUsers.rejected, (state) => {
      state.loading = false;
    });

    //------assign post
    builder.addCase(addAssignProspectLead.pending, (state) => {
      state.loading = true;
      state.success = false;
    });

    builder.addCase(addAssignProspectLead.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    });

    builder.addCase(addAssignProspectLead.rejected, (state) => {
      state.loading = false;
      state.success = false;
    });

    //--------------------get lsq prospects
    builder.addCase(getLsqProspects.pending, (state) => {
      state.lsqTable.loading = true;
    });
    builder.addCase(getLsqProspects.fulfilled, (state, action) => {
      state.lsqTable.loading = false;
      state.lsqTable.data = action.payload.data || [];
      state.lsqTable.meta = action.payload?.meta;
    });
    builder.addCase(getLsqProspects.rejected, (state) => {
      state.lsqTable.loading = false;
    });
  },
});

export const { clearDistrict, clearstate } = globalSlice.actions;
export default globalSlice.reducer;
